import React, { Component } from "react";
import { connect } from "react-redux";

import * as sisMapActions from "store/modules/rds_sisMap";
import * as layoutActions from "store/modules/rds_layout";

import SisModal from "store/sis/sisModal";
import SisPagination from "store/sis/component/SisPagination";

import stl from "./WorkInfoModal.module.scss";
import { bindActionCreators } from "redux";

//import lodash from "lodash";

class WorkInfoModal extends Component {
	state = {
		pagination: <SisPagination />,
		info: {},
	};


	componentDidMount() {
		const { LayoutActions } = this.props;

		LayoutActions.setModal({
			id: "workInfoModal",
			target: this.workInfoModal,
		});

		
	}

	render() {
		
		const { info } = this.state;

		const contents = (
			<div className={stl.contentWrapper}>
				
				<div className={stl.contentBody}>
					<div className={`${stl.tabContent}`}>
						<table>
							<caption>사업정보</caption>
							<tbody>
								<tr>
									<th className={`${stl.leftHeader} ${stl.l25}`}>사업명</th>
									<td>{info.title ? info.title : "-"}</td>
								</tr>
								<tr>
									<th className={`${stl.leftHeader} ${stl.l50}`}>위치</th>
									<td>{info.location ? info.location : "-"}</td>
									<th className={`${stl.leftHeader} ${stl.l50}`}>사업규모</th>
									<td>{info.cost ? info.cost : "-"}</td>
								</tr>
								<tr>
									<th className={`${stl.leftHeader} ${stl.l50}`}>총사업비</th>
									<td>{info.location ? info.location : "-"}</td>
									<th className={`${stl.leftHeader} ${stl.l50}`}>사업기간</th>
									<td>{info.cost ? info.cost : "-"}</td>
								</tr>
								<tr>
									<th className={`${stl.leftHeader} ${stl.l50}`}>추친단계</th>
									<td>{info.location ? info.location : "-"}</td>
									<th className={`${stl.leftHeader} ${stl.l50}`}>추친기간</th>
									<td>{info.cost ? info.cost : "-"}</td>
								</tr>
								<tr>
									<th className={`${stl.leftHeader} ${stl.l50}`}>공정률(%)</th>
									<td>{info.location ? info.location : "-"}</td>
									<th className={`${stl.leftHeader} ${stl.l50}`}>시행기관</th>
									<td>{info.cost ? info.cost : "-"}</td>
								</tr>
								<tr>
									<th className={`${stl.leftHeader} ${stl.l50}`}>담당부서</th>
									<td>{info.location ? info.location : "-"}</td>
									<th className={`${stl.leftHeader} ${stl.l50}`}>연락처</th>
									<td>{info.cost ? info.cost : "-"}</td>
								</tr>
								<tr>
									<th className={`${stl.leftHeader} ${stl.l50}`}>비고</th>
									<td>{info.location ? info.location : "-"}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		);

		return (
			<div>
				<SisModal
					id={this.props.id}
					ref={(ref) => (this.workInfoModal = ref)}
					className={stl.workInfoModal}
					draggable
					title="정보보기"
					contents={contents}
				/>
			</div>
		);
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		SisMapActions: bindActionCreators(sisMapActions, dispatch),
		LayoutActions: bindActionCreators(layoutActions, dispatch),
	})
)(WorkInfoModal);
